<div class="mt-3">
  <!-- Gruppen-Parameter (wie in der alten SWA-Lösung) -->
  <div class="card rounded-0 shadow p-2 mb-3" *ngIf="activeGroup">
    <div class="fw-semibold mb-1">
      Stauwarnanlagen-Einstellungen: <span class="text-danger">{{ activeGroup.name }}</span>
      <span class="text-danger" *ngIf="!activeGroup.isActive"> – Gruppe ist deaktiviert</span>
    </div>

    <!-- Admin: editierbar -->
    <ng-container *ngIf="isEditor; else groupReadonly">
      <div class="d-flex mt-2 gap-2 flex-wrap">
        <div class="flex-grow-1" style="min-width: 220px;">
          <div class="ms-2 mb-1">Gruppentyp</div>
          <div [ngClass]="isGroupTypesSelectOpen ? 'border-danger' : ''"
            class="border d-flex justify-content-between" role="button" (click)="onGroupTypeSelectClicked()">
            <div class="ms-2 p-1">{{ getGroupTypeString(activeGroup.groupType) }}</div>
            <img class="me-2" [src]="isGroupTypesSelectOpen ? 'assets/icons/caret-up.svg' : 'assets/icons/caret-down.svg'" alt="">
          </div>
          <avs-dropdown *ngIf="isGroupTypesSelectOpen" [isHeaderActive]="false"
            [activeItem]="onGetActiveSelect(GroupMetaDataTypes.groupType, activeGroup.groupType)"
            (onItemClicked)="onMetaValueChange($event, GroupMetaDataTypes.groupType)" [selectInput]="groupTypeSelect">
          </avs-dropdown>
        </div>
        <div class="flex-grow-1" style="min-width: 220px;">
          <div class="ms-2 mb-1">Diagrammtyp</div>
          <div [ngClass]="isDiagramTypesSelectOpen ? 'border-danger' : ''"
            class="border d-flex justify-content-between" role="button" (click)="onDiagramTypeSelectClicked()">
            <div class="ms-2 p-1">{{ getDiagramTypeString(activeGroup.diagramType) }}</div>
            <img class="me-2" [src]="isDiagramTypesSelectOpen ? 'assets/icons/caret-up.svg' : 'assets/icons/caret-down.svg'" alt="">
          </div>
          <avs-dropdown *ngIf="isDiagramTypesSelectOpen" [isHeaderActive]="false"
            [activeItem]="onGetActiveSelect(GroupMetaDataTypes.diagramType, activeGroup.diagramType)"
            (onItemClicked)="onMetaValueChange($event, GroupMetaDataTypes.diagramType)" [selectInput]="diagramTypeSelect">
          </avs-dropdown>
        </div>
      </div>
      <div class="d-flex mt-2 gap-2 flex-wrap">
        <div class="flex-grow-1" style="min-width: 220px;">
          <div class="ms-2 mb-1">Fahrbahn Regeln</div>
          <div [ngClass]="isTrafficRulesSelectOpen ? 'border-danger' : ''"
            class="border d-flex justify-content-between" role="button" (click)="onTrafficRulesSelectClicked()">
            <div class="ms-2 p-1">{{ getTrafficRulesString(activeGroup.trafficRules) }}</div>
            <img class="me-2" [src]="isTrafficRulesSelectOpen ? 'assets/icons/caret-up.svg' : 'assets/icons/caret-down.svg'" alt="">
          </div>
          <avs-dropdown *ngIf="isTrafficRulesSelectOpen" [isHeaderActive]="false"
            [activeItem]="onGetActiveSelect(GroupMetaDataTypes.trafficRules, activeGroup.trafficRules)"
            (onItemClicked)="onMetaValueChange($event, GroupMetaDataTypes.trafficRules)" [selectInput]="trafficRulesSelect">
          </avs-dropdown>
        </div>
        <div class="flex-grow-1" style="min-width: 220px;">
          <div class="ms-2 mb-1">Fahrbahn Spuren (1-10)</div>
          <input type="number" style="height: 34px;" class="ms-2 rounded-0 form-control" min="1" max="10"
            [ngModel]="trafficLanes" (ngModelChange)="changeTrafficLane($event)">
        </div>
      </div>
      <div class="d-flex justify-content-end mt-2">
        <button class="btn btn-outline-success rounded-0" type="button"
          *ngIf="groupMetaData || isTrafficLanesChanged" (click)="onSaveMetaDataClicked()">Änderung übernehmen</button>
      </div>
    </ng-container>

    <!-- Nur-Lese-Ansicht (User) -->
    <ng-template #groupReadonly>
      <div class="d-flex flex-wrap gap-4 mt-1 ms-2">
        <div><span class="text-secondary small d-block">Gruppentyp</span>{{ getGroupTypeString(activeGroup.groupType) }}</div>
        <div><span class="text-secondary small d-block">Diagrammtyp</span>{{ getDiagramTypeString(activeGroup.diagramType) }}</div>
        <div><span class="text-secondary small d-block">Fahrbahn Regeln</span>{{ getTrafficRulesString(activeGroup.trafficRules) }}</div>
        <div><span class="text-secondary small d-block">Fahrbahn Spuren</span>{{ trafficLanes }}</div>
      </div>
    </ng-template>
  </div>

  <!-- Toolbar / Legende -->
  <div class="card shadow rounded-0 p-3 mb-3">
    <div class="d-flex flex-wrap align-items-center gap-2">
      <span class="fw-bold me-2">{{ mode === 'edit' ? 'Aktive Line' : 'Line-Zusammenhänge' }}</span>

      <!-- Ansicht: Legende -->
      <ng-container *ngIf="mode === 'view'">
        <button *ngFor="let entry of legend" type="button"
          class="avs-swa-chip-btn" [class.active]="selectedLine === entry.line"
          [style.boxShadow]="selectedLine === entry.line ? ('0 0 0 1px ' + entry.color) : null"
          (click)="onLegendClick(entry.line)">
          <span class="avs-swa-swatch" [style.background]="entry.color"></span>
          Line {{ entry.line }} <span class="avs-swa-count">{{ entry.count }}×</span>
        </button>
        <span *ngIf="legend.length === 0" class="text-secondary small">Keine Line-Zuordnungen vorhanden.</span>
      </ng-container>

      <!-- Bearbeiten: Pinsel-Auswahl -->
      <ng-container *ngIf="mode === 'edit'">
        <button *ngFor="let line of brushLines" type="button"
          class="avs-swa-chip-btn" [class.active]="isActiveBrush(line)"
          [style.boxShadow]="isActiveBrush(line) ? ('0 0 0 1px ' + getColor(line)) : null"
          (click)="onLegendClick(line)">
          <span class="avs-swa-swatch" [style.background]="getColor(line)"></span>
          Line {{ line }} <span class="avs-swa-count" *ngIf="isNewBrushLine(line)">neu</span>
        </button>
        <button type="button" class="avs-swa-chip-btn" [class.active]="isActiveBrush('erase')" (click)="setEraser()">
          <span class="avs-swa-swatch avs-swa-eraser"></span> Keine Line
        </button>
      </ng-container>

      <span class="flex-grow-1"></span>

      <span *ngIf="mode === 'view' && selectedLine" class="text-secondary small me-2">
        {{ selectedCount }} Komponenten in Line {{ selectedLine }}
      </span>
      <button *ngIf="mode === 'view' && selectedLine" type="button"
        class="btn btn-sm btn-outline-secondary rounded-0" (click)="clearSelection()">Auswahl aufheben</button>

      <!-- Bearbeiten-Umschalter (nur Voll-Admin) -->
      <ng-container *canAccess="[1]">
        <button *ngIf="mode === 'view'" type="button" class="btn btn-sm btn-outline-danger rounded-0"
          (click)="enterEditMode()">Line bearbeiten</button>
        <ng-container *ngIf="mode === 'edit'">
          <button type="button" class="btn btn-sm btn-outline-secondary rounded-0 me-2"
            (click)="cancelEditMode()">Abbrechen</button>
          <button type="button" class="btn btn-sm btn-outline-success rounded-0"
            [disabled]="!hasPendingChanges" (click)="saveEditMode()">Speichern</button>
        </ng-container>
      </ng-container>
    </div>

    <p class="text-secondary small mb-0 mt-2" *ngIf="mode === 'edit'">
      Bearbeiten-Modus: aktive Line wählen und Komponenten anklicken, um sie zuzuordnen
      (erneuter Klick entfernt). „Keine Line“ wirkt als Radierer.
    </p>
    <p class="text-secondary small mb-0 mt-2" *ngIf="mode === 'view'">
      Klick auf eine Line hebt zusammengehörige Komponenten hervor. Klick auf eine Komponente
      zeigt die Engine-Parameter<span *canAccess="[1]"> bzw. öffnet den Editor</span>.
    </p>

    <div class="d-flex flex-wrap align-items-center gap-3 mt-2 text-secondary small">
      <span class="d-inline-flex align-items-center gap-1">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M13 6l6 6-6 6"/></svg>
        steuert (MQ, Dig. Eingang)
      </span>
      <span class="d-inline-flex align-items-center gap-1">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.5"/></svg>
        wird gesteuert (AQ, Blinker, Prismenwender, Dig. Ausgang)
      </span>
    </div>
  </div>

  <!-- Board: Spalten nach Position X (oben Mittelstreifen, unten Randstreifen, an X ausgerichtet) -->
  <div class="avs-swa-board">
    <div class="avs-swa-track" #track>
      <!-- Verbindungspfeile: steuernde -> gesteuerte Elemente der hervorgehobenen Line -->
      <svg class="avs-swa-connectors" *ngIf="connectors.length" [attr.width]="trackSize.w" [attr.height]="trackSize.h">
        <defs>
          <marker id="swaArrow" markerWidth="16" markerHeight="16" refX="12" refY="8" orient="auto" markerUnits="userSpaceOnUse">
            <path d="M0,1 L16,8 L0,15 Z" [attr.fill]="connectorColor"></path>
          </marker>
        </defs>
        <line *ngFor="let c of connectors" [attr.x1]="c.x1" [attr.y1]="c.y1" [attr.x2]="c.x2" [attr.y2]="c.y2"
          [attr.stroke]="connectorColor" stroke-width="3" marker-end="url(#swaArrow)" opacity="0.55"></line>
      </svg>

      <!-- obere Reihe -->
      <div class="avs-swa-row">
        <div class="avs-swa-cols">
          <div class="avs-swa-col" *ngFor="let column of board.columns; trackBy: trackByColumnX"
            [style.width.px]="columnWidth(column)">
            <div class="avs-swa-col-inner">
              <ng-container *ngFor="let station of column.top; trackBy: trackByStationId">
                <ng-container *ngTemplateOutlet="stationCard; context: { $implicit: station }"></ng-container>
              </ng-container>
            </div>
          </div>
          <div *ngIf="board.columns.length === 0" class="text-secondary small p-2">Keine Stationen</div>
        </div>
      </div>

      <!-- Straße (Design wie alte Lösung) -->
      <div class="avs-swa-row avs-swa-road-row">
        <div class="avs-swa-road-wrap">
          <div class="avs-schema-road">
            <div class="avs-schema-road-middle-strip"></div>
            <div class="avs-schema-road-stripe"></div>
            <div class="avs-schema-road-middle-strip"></div>
            <div class="avs-schema-road-end"></div>
          </div>
        </div>
      </div>

      <!-- untere Reihe -->
      <div class="avs-swa-row">
        <div class="avs-swa-cols">
          <div class="avs-swa-col" *ngFor="let column of board.columns; trackBy: trackByColumnX"
            [style.width.px]="columnWidth(column)">
            <div class="avs-swa-col-inner">
              <ng-container *ngFor="let station of column.bottom; trackBy: trackByStationId">
                <ng-container *ngTemplateOutlet="stationCard; context: { $implicit: station }"></ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Stationen ohne Fahrbahn-Zuordnung -->
  <div *ngIf="board.unassigned.length" class="mt-3">
    <div class="fw-semibold small text-secondary mb-2">Ohne Fahrbahn-Zuordnung</div>
    <div class="d-flex flex-wrap gap-3">
      <ng-container *ngFor="let station of board.unassigned; trackBy: trackByStationId">
        <ng-container *ngTemplateOutlet="stationCard; context: { $implicit: station }"></ng-container>
      </ng-container>
    </div>
  </div>
</div>

<!-- Stationskarte -->
<ng-template #stationCard let-station>
  <div class="avs-swa-station card rounded-0">
    <div class="avs-swa-station-head">
      <div class="avs-swa-position">
        <img *ngIf="getPositionPiktogramm(station) as pikto" [src]="pikto" class="avs-swa-pikto" alt="">
        <span>{{ getPositionLabel(station) }}</span>
      </div>
      <div class="avs-swa-station-name">{{ station.routeStation.name }}</div>
      <div class="avs-swa-station-sam">SAM-ID {{ station.routeStation.samId }}</div>
    </div>
    <div class="avs-swa-chips" [class.avs-swa-editing]="mode === 'edit'">
      <button *ngFor="let channel of visibleChannels(station); trackBy: trackByChannelId" type="button"
        class="avs-swa-chip"
        [attr.data-line]="channel.line"
        [attr.data-role]="getRole(channel)"
        [class.dimmed]="isDimmed(channel)"
        [class.no-line]="!channel.line"
        [style.borderLeftColor]="getColor(channel.line)"
        [style.boxShadow]="isHighlighted(channel) ? ('0 0 0 2px ' + getColor(channel.line)) : null"
        (click)="onChannelClick(station, channel)">
        <span class="avs-swa-dot" [style.background]="getColor(channel.line)"></span>
        <span class="avs-swa-chip-text">
          <span class="avs-swa-chip-name">{{ getLabel(station, channel)?.name }}</span>
          <span class="avs-swa-chip-sub" *ngIf="getLabel(station, channel)?.sublabel">{{ getLabel(station, channel)?.sublabel }}</span>
        </span>
        <span class="avs-swa-role" *ngIf="getRole(channel) as role" [style.color]="getColor(channel.line)"
          [title]="role === 'source' ? 'Steuert' : 'Wird gesteuert'" [ngSwitch]="role">
          <svg *ngSwitchCase="'source'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M13 6l6 6-6 6"/></svg>
          <svg *ngSwitchCase="'target'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.5"/></svg>
        </span>
        <span class="avs-swa-line-badge" [style.background]="channel.line ? getColor(channel.line) : null">
          {{ channel.line ? ('L' + channel.line) : '—' }}
        </span>
      </button>
      <div *ngIf="visibleChannels(station).length === 0" class="text-secondary small p-2">Keine Komponenten</div>
    </div>
  </div>
</ng-template>
